import { render, staticRenderFns } from "./PanelMoneyAvg.vue?vue&type=template&id=113809b1"
import script from "./PanelMoneyAvg.vue?vue&type=script&lang=js"
export * from "./PanelMoneyAvg.vue?vue&type=script&lang=js"
import style0 from "./PanelMoneyAvg.vue?vue&type=style&index=0&id=113809b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports